import { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { UserContext } from '../App';
import Frame from '../layout/Frame';
import { Button, Checkbox, Input, Popup } from '../components';
import { AppRoute, ButtonType, InputType } from '../types/enums';
import { fetchRegister } from '../requests/requests';
import { isPasswordAcceptable, isValidEmail } from '../utils/common';
import useErrorHandler from '../hooks/useErrorHandler';
import { setBearerToken } from '../utils/auth';

import lockIcon from '../components/Input/lock-solid.svg';
import mailIcon from '../components/Input/envelope-regular.svg';

const Register = () => {
  const { setUser } = useContext(UserContext);
  const errorHandler = useErrorHandler();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [checked, setChecked] = useState(false);
  const [errors, setErrors] = useState<{ email?: boolean; password?: boolean; terms?: boolean }>(
    {}
  );

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const err = {
      email: !isValidEmail(email),
      password: !isPasswordAcceptable(password),
      terms: !checked
    };

    setErrors(err);

    if (!Object.values(err).some((val) => val)) {
      fetchRegister(email, password, emailToName(email)).then(({ data }) => {
        setBearerToken(data.accessToken);
        setUser(data.user);
      }, errorHandler);
    }
  };

  return (
    <Frame>
      <Popup show title="Sign up for monitormonk" permanent>
        <div>
          <form onSubmit={onSubmit}>
            <Input
              id="email"
              label="E-mail:"
              value={email}
              setValue={setEmail}
              placeholder="youremail@gmail.com"
              icon={mailIcon}
              error={errors.email ? 'Please enter a valid email address' : ''}
            />
            <Input
              id="password"
              label="Password:"
              value={password}
              setValue={setPassword}
              placeholder="your password"
              icon={lockIcon}
              type={InputType.PASSWORD}
              error={errors.password ? 'Minimum 8 characters required' : ''}
            />
            <Checkbox
              id="terms"
              label={
                <div>
                  I have read the <a href="#">terms and conditions</a> of MonitorMonk and accept
                  them.
                </div>
              }
              value={checked}
              setValue={setChecked}
              error={errors.terms ? 'Error: Must be accepted to continue' : ''}
            />
            <Button type={ButtonType.PRIMARY} fullWidth isSubmit>
              Sign up
            </Button>
            <p>
              <strong>
                Already have and account?&nbsp;
                <NavLink className="color-orange" to={AppRoute.LOGIN}>
                  Log in here!
                </NavLink>
              </strong>
            </p>
          </form>
        </div>
      </Popup>
    </Frame>
  );
};

const emailToName = (email: string) => {
  let output = '';

  const identifierIsCommon = matchIdentifierToList(email, [
    'hello',
    'hi',
    'me',
    'email',
    'contact'
  ]);

  if (identifierIsCommon) {
    output = reverseDomainAndIdentifier(email);
  } else {
    output = email.split('@')[0];
  }

  output = output.split('+')[0];
  output = output.replace(/\d/g, '');
  output = output.replace(/\./g, ' ');
  output = output.replace(/_/g, ' ');
  output = output.replace(/\s\s+/g, ' ');
  output = output.trim();
  output = capitalCase(output);

  return output;
};

const matchIdentifierToList = (str: string, identifiers: string[]) =>
  identifiers.includes(str.split('@')[0]);

function reverseDomainAndIdentifier(str: string) {
  const provider = str.split('@')[1];
  const host = provider.split('.')[0];

  return host;
}

function capitalCase(str: string) {
  return str
    .toLowerCase()
    .split(' ')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

export default Register;
